import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const COLORS = ["#22c55e", "#f59e0b", "#ef4444", "#8b5cf6"];

function DarkTooltip({ active, payload }) {
  if (!active || !payload || !payload.length) return null;
  const entry = payload[0];
  return (
    <div
      style={{
        background: "rgba(5,12,24,0.96)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 12,
        padding: "10px 12px",
        color: "#fff",
        boxShadow: "0 12px 30px rgba(0,0,0,0.35)",
      }}
    >
      <div style={{ fontSize: 12, fontWeight: 800 }}>{entry.name}</div>
      <div style={{ fontSize: 12, marginTop: 4 }}>{entry.value}</div>
    </div>
  );
}

export default function ShiftDonutChart({ data = [], title = "Shift Outcomes", subtitle = "", summary = [] }) {
  const cleanData = data.filter((item) => Number(item.value || 0) > 0);
  const total = cleanData.reduce((sum, item) => sum + Number(item.value || 0), 0);

  return (
    <div
      style={{
        background: "linear-gradient(180deg, rgba(10,24,54,0.96), rgba(5,14,33,0.96))",
        border: "1px solid rgba(255,255,255,0.06)",
        borderRadius: 18,
        padding: 16,
        minHeight: 340,
      }}
    >
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 17, fontWeight: 900, color: "#fff" }}>{title}</div>
        {subtitle ? <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>{subtitle}</div> : null}
      </div>

      <ResponsiveContainer width="100%" height={210}>
        <PieChart>
          <Tooltip content={<DarkTooltip />} />
          <Pie data={cleanData} dataKey="value" innerRadius={58} outerRadius={92} paddingAngle={3}>
            {cleanData.map((item, i) => <Cell key={item.name || i} fill={COLORS[i % COLORS.length]} />)}
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      <div style={{ marginTop: -128, pointerEvents: "none", textAlign: "center" }}>
        <div style={{ fontSize: 26, fontWeight: 900, color: "#fff" }}>{total}</div>
        <div style={{ fontSize: 11, opacity: 0.62 }}>shift records today</div>
      </div>

      <div style={{ display: "grid", gap: 10, marginTop: 8 }}>
        {cleanData.map((item, i) => (
          <div key={item.name || i} style={{ display: "flex", justifyContent: "space-between", gap: 10, fontSize: 12 }}>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <span style={{ width: 10, height: 10, borderRadius: 999, background: COLORS[i % COLORS.length], display: "inline-block" }} />
              <span style={{ opacity: 0.88 }}>{item.name}</span>
            </div>
            <span style={{ opacity: 0.78 }}>{item.value}</span>
          </div>
        ))}
      </div>

      {summary.length ? (
        <div
          style={{
            marginTop: 12,
            borderTop: "1px solid rgba(255,255,255,0.06)",
            paddingTop: 12,
            display: "grid",
            gap: 8,
          }}
        >
          {summary.map((text, idx) => (
            <div
              key={idx}
              style={{
                fontSize: 12,
                padding: "8px 10px",
                borderRadius: 12,
                background: "rgba(255,255,255,0.04)",
                color: "#d8e4ff",
              }}
            >
              {text}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
